import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class BigErrorIcon extends BaseIcon {
  getChildren = () => [
    <path fill="#e54848" d="M0,20a20,20 0 1,0 40,0a20,20 0 1,0 -40,0"/>,
    <path fill="#fff"
          d="M28.250,15.200 L23.309,20.141 L28.247,25.079 L24.958,28.368 L20.020,23.430 L15.077,28.372 L11.788,25.083 L16.731,20.141 L11.786,15.196 L15.075,11.907 L20.020,16.851 L24.960,11.911 L28.250,15.200 Z"/> ]
  getViewBox = () => '0 0 40 40'
}
